import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import ForgetForm from "../components/ForgetForm/ForgetForm"
import Footer from "../components/Footer/Footer"
import PageHeader from '../components/PageHeader/PageHeader'

function ForgetPassword() {
  return (
    <>
<Navbar/>
{/* <PageHeader title={'Forget Password'}/> */}
<ForgetForm/>
<Footer/>
    </>  )
}

export default ForgetPassword